<template>
  <v-container class="my-account" fluid>
    <v-row class="my-account-wrapper">
      <v-tabs v-model="tabIndex"
              show-arrows
              background-color="rgb(239, 239, 239)"
              :vertical="pageWidth >= 960">
        <v-tab>
          {{ $t('my_account.account_info') }}
        </v-tab>
        <v-tab>
          {{ $t('my_account.past_event') }}
        </v-tab>
        <v-tab>
          {{ $t('my_account.my_booking') }}
        </v-tab>
        <v-tab>
          {{ $t('my_account.gym_subscriptions') }}
        </v-tab>
        <v-tab>
          {{ $t('my_account.gym_bookings') }}
        </v-tab>
        <!--        <v-tab>-->
        <!--          {{ $t('my_account.points') }}-->
        <!--        </v-tab>-->
        <v-tab>
          {{ $t('my_account.coupon') }}
        </v-tab>
        <!--        <v-tab>-->
        <!--          {{ $t('my_account.package') }}-->
        <!--        </v-tab>-->
        <v-tab>
          {{ $t('my_account.invoice') }}
        </v-tab>

        <v-tab-item>
          <AccountInfo v-if="tabIndex === 0"></AccountInfo>
        </v-tab-item>
        <v-tab-item>
          <MyEventList v-if="tabIndex === 1"></MyEventList>
        </v-tab-item>
        <v-tab-item>
          <!--          <BookingList v-if="tabIndex === 2"></BookingList>-->
          <UserBookingList v-if="tabIndex === 2"></UserBookingList>
        </v-tab-item>
        <v-tab-item>
          <GymSubscriptionList v-if="tabIndex === 3"></GymSubscriptionList>
        </v-tab-item>
        <v-tab-item>
          <UserGymBookingList v-if="tabIndex === 4"></UserGymBookingList>
          <!--          <GymSubscriptionCheckInRecordList v-if="tabIndex === 4"></GymSubscriptionCheckInRecordList>-->
        </v-tab-item>
        <!--        <v-tab-item>-->
        <!--          <PointBalance v-if="tabIndex === 5"></PointBalance>-->
        <!--        </v-tab-item>-->
        <v-tab-item>
          <v-row>
            <v-col class="text-right">
              <v-btn rounded
                     class="mr-2 mt-2"
                     color="primary"
                     @click="redeemCoupon">
                <v-icon>mdi-ticket</v-icon>
                <span class="font-size-35">{{ $t('coupon.redeem_title') }}</span>
              </v-btn>
            </v-col>
          </v-row>
          <CouponList v-if="tabIndex === 5"
                      :refresh-trigger.sync="couponRefreshTrigger"></CouponList>
        </v-tab-item>
        <!--        <v-tab-item>-->
        <!--          <UserPackageList v-if="tabIndex === 7"></UserPackageList>-->
        <!--        </v-tab-item>-->
        <v-tab-item>
          <InvoiceList v-if="tabIndex === 6"></InvoiceList>
        </v-tab-item>
      </v-tabs>
    </v-row>
  </v-container>
</template>

<script>

import AccountInfo from "./Hkiarace/AccountInfo";
import MyEventList from "./Hkiarace/MyEventList";
import BookingList from "./AccBooking/BookingList";
import CouponList from "@/components/acc_booking/coupon/CouponList.vue";
import GymSubscriptionList from "@/components/acc_booking/GymSubscriptionList";
import GymSubscriptionCheckInRecordList from "@/components/acc_booking/GymSubscriptionCheckInRecordList";
import PointBalance from "@/views/client/PointBalance";
import UserBookingList from "@/components/booking/UserBookingList";
import UserPackageList from "@/components/acc_booking/UserPackageList";
import UserGymBookingList from "@/components/acc_booking/UserGymBookingList";
import InvoiceList from "@/components/acc_booking/invoice/InvoiceList.vue";
import {ref} from "@vue/composition-api";
import RedeemCouponModal from "@/components/acc_booking/coupon/RedeemCouponModal.vue";

export default {
  name: 'MyAccount',
  components: {InvoiceList, UserGymBookingList, UserPackageList, UserBookingList, PointBalance, GymSubscriptionCheckInRecordList, GymSubscriptionList, CouponList, BookingList, MyEventList, AccountInfo},
  setup(props, {root}) {
    const couponRefreshTrigger = ref(false);
    const redeemCoupon = async function () {
      const needRefresh = await root.$dialog.showAndWait(RedeemCouponModal, {
        showClose: false,
        persistent: true,
        width: '300px',
      });

      if (needRefresh) {
        couponRefreshTrigger.value = true;
      }
    }

    return {
      redeemCoupon,
      couponRefreshTrigger,
    }
  },


  mounted() {
    let v = this;
    setTimeout(function () {
      v.tabIndex = parseInt(v.$route.query.t || "0");
    }, 50)
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.pageWidth = window.innerWidth;
      });
    });
  },
  data() {
    return {
      tabIndex: 0,
      pageWidth: window.innerWidth,
    }
  },
  watch: {
    "$route.query.t"(newVal) {
      this.tabIndex = newVal;
    },
    tabIndex(newVal) {
      this.$router.replace({
        name: this.$route.name,
        params: this.$route.params,
        query: {...this.$route.query, t: newVal}
      })
    },
  },
  methods: {
    tabChanged(tabIndex) {
      this.$router.replace({
        name: this.$route.name,
        params: this.$route.params,
        query: {...this.$route.query, t: tabIndex}
      })
    },
  },
}
</script>

<style lang="less">
.my-account {
  padding-left: 0%;
  padding-right: 0%;

  .my-account-wrapper {
    padding: 0rem;
    /*padding-left: 10%;*/
    /*padding-right: 10%;*/
    /*padding-top: 64px;*/
    /*padding-bottom: 64px;*/
    background-color: rgb(239, 239, 239);
  }


  .nav-tabs {
    border: none;

    .nav-link {
      color: #495057;

      &:hover {
        border-color: transparent transparent #222 transparent;
      }

      &.active {
        font-weight: bold;
        border-color: transparent transparent #222 transparent;
      }
    }
  }
}

@media only screen and (min-width: 960px) {
  .my-account {
    padding-left: 3%;
    padding-right: 3%;

    .my-account-wrapper {
      /*padding-left: 10%;*/
      /*padding-right: 10%;*/
      /*padding-top: 64px;*/
      /*padding-bottom: 64px;*/
    }
  }
}
</style>
